import {
  Documents,
  isDocument,
} from "@ca-dmv-radv/screens/src/dashboard/helpers/constants";

export const getExpirationTranslationKey = (documentType, isNchOrRnc) => {
  const is = (...types) => types.some((type) => isDocument(type, documentType));
  let translationKey = "Expiration-form-Expiration-invalid-date";

  // DL and ID share the same rule, so ID reuses the DL translation key.
  // The base key translates to the generic "valid, unexpired" message.
  if (
    is(
      Documents.DRIVERS_LICENSE,
      Documents.CA_DRIVERS_LICENSE,
      Documents.ID_CARD,
      Documents.CA_ID_CARD
    )
  ) {
    translationKey += "-dl";
    return {
      key: translationKey,
      default:
        "Expiration Date cannot be more than one year after the original expiration date or more than 10 years from today.",
    };
  }
  if (is(Documents.PASSPORT, Documents.PASSPORT_CARD)) {
    if (isNchOrRnc) {
      translationKey += "-passport-nch";
      return {
        key: translationKey,
        default:
          "Expiration date must be at least 2 days from today and not more than 10 years from today.",
      };
    }
    translationKey += "-passport-id";
    return {
      key: translationKey,
      default:
        "Expiration date must be at least 30 days from today and not more than 10 years from today.",
    };
  }

  return {
    key: translationKey,
    default: "Expiration date must be valid, unexpired",
  };
};
